module.exports = ".limit-exceeded {\n  color: #cd0a0a; }\n"